import posthog from "posthog-js";

const POSTHOG_KEY = "phc_s9KMbArsQEmTx2ymihk8ragm2LXvW3GZQu6LYgxMqRJ7";
const POSTHOG_HOST = "https://app.posthog.com";

let initialized = false;

export const initAnalytics = () => {
  if (initialized) return;
  if (typeof window === "undefined") return;
  if (window.location.pathname.startsWith("/admin")) return;

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    capture_pageview: true,
    capture_pageleave: true,
    disable_surveys: true,
  });
  initialized = true;
};

export const track = (event: string, properties?: Record<string, unknown>) => {
  if (typeof window === "undefined") return;
  if (window.location.pathname.startsWith("/admin")) return;
  if (!initialized) return;
  try {
    posthog.capture(event, properties);
  } catch (err) {
    console.error("posthog capture error", err);
  }
};

export { posthog };
